<mwe-product-tariff-card-template
  [product]="product()"
  [headlineReference]="headlineService.getHeadline(0)"
  [hasContent]="true"
  data-test="tariff-card-internet"
>
  <mwe-infobox messageKey="products.details.card.priceInfo" type="neutral" />
</mwe-product-tariff-card-template>
